// @ts-check
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAuth = defineStore('auth', () => {
    const loggedIn = ref(false)
    const provisionShopCode = ref()
    const lineId = ref()
    const brandSite = ref()
    const cardNumber = ref()


    /**
     * ログイン処理（LINEログイン情報設定）
     * @param {string} _provisionShopCode
     * @param {string} _lineId
     * @param {string} _brandSite brandSite
     * @param {string} _cardNumber
     */
    function login(_provisionShopCode, _lineId, _brandSite, _cardNumber) {
        loggedIn.value = true
        provisionShopCode.value = _provisionShopCode
        lineId.value = _lineId
        brandSite.value = _brandSite
        cardNumber.value = _cardNumber
    }

    /**
     * ログアウト処理（LINEログイン情報設定クリア）
     */
    function logout() {
        loggedIn.value = false
        provisionShopCode.value = null
        lineId.value = null
        brandSite.value = null
        cardNumber.value = null
    }

    /** LINEログイン情報 */
    const LINELoginData = computed(() => ({
        /** ログイン可否 */
        isLoggedIn: loggedIn.value,
        /** プロビジョン販売店コード */
        provisionShopCode: provisionShopCode.value,
        /** LINE ID */
        lineId: lineId.value,
        /** ブランドサイトコード */
        brandSite: brandSite.value,
        /** メンバーズ会員番号 */
        cardNumber: cardNumber.value,
    }))

    return {
        login,
        logout,
        LINELoginData,
    }
})
